// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2T67P","search":"Settings_search__3Q1Rd","filter":"Settings_filter__jxuAL"};